import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
  putRequest,
} from "./ApiRequest";

// Carte dei vini (e menu): API del backend `menucard/`. Le risposte hanno la forma { success, message, data }.
const M = "menucard";

export const GetMenuCardsAPI = ({ page = 1, perPage = 10, query = "", order = "latest" } = {}) =>
  getRequest(
    `${M}/requests?page=${page}&per_page=${perPage}&query=${encodeURIComponent(query)}&order=${order}`
  );
export const AddMenuCardAPI = (payload) => postRequest(`${M}/requests`, payload);
export const UpdateMenuCardAPI = (id, payload) => patchRequest(`${M}/requests/${id}`, payload);
export const DeleteMenuCardAPI = (id) => deleteRequest(`${M}/requests/${id}`);

// Carta con le sezioni e i prodotti assegnati; con includeUnavailable si vedono anche i vini esauriti.
export const GetMenuCardAPI = (id, includeUnavailable = true) =>
  getRequest(`${M}/requests/${id}?include_unavailable=${includeUnavailable}`);

// Sostituisce l'elenco dei prodotti della carta con quello inviato.
export const AssignProductsAPI = (id, products) =>
  postRequest(`${M}/requests/${id}`, { products });

// Prodotti che si possono mettere in carta (vini con scheda nel dataset Wine Data).
// kind "food": i piatti di Food Product (per le Food Cards); altrimenti i vini (Drinks Cards).
export const GetCardProductsAPI = ({ page = 1, perPage = 10, query = "", order = "latest", kind = "drinks" } = {}) =>
  getRequest(
    `${M}/requests/product?page=${page}&per_page=${perPage}&query=${encodeURIComponent(query)}&order=${order}&kind=${kind}`
  );

// Struttura della carta: categorie e sottocategorie con i vini collocati e quelli da collocare.
export const GetStructureAPI = (id) => getRequest(`${M}/requests/${id}/structure`);
export const SaveStructureAPI = (id, body) => putRequest(`${M}/requests/${id}/structure`, body);
// Modifica un piatto (o il prezzo di un vino) dalla carta: scope "local", "all" o "reset".
export const EditCardProductAPI = (cardId, productId, body) => patchRequest(`${M}/requests/${cardId}/products/${productId}`, body);

// Nuovo ordine delle carte (elenco degli uuid nell'ordine voluto).
export const ReorderCardsAPI = (cards) => postRequest(`${M}/requests/reorder`, { cards });

// Immagine di copertina della carta.
export const UploadCardImageAPI = (id, file) => {
  const form = new FormData();
  form.append("image", file);
  return postRequest(`${M}/requests/${id}/image`, form);
};
export const DeleteCardImageAPI = (id) => deleteRequest(`${M}/requests/${id}/image`);

// AI: propone la struttura di una carta (non salva) o crea carte nuove dai vini del ristorante.
export const AIStructureAPI = (id, instruction) =>
  postRequest(`${M}/requests/${id}/structure/ai`, { instruction });
export const AICardsAPI = (instruction, kind = "drinks") => postRequest(`${M}/ai/cards`, { instruction, kind });
